import React from "react";
import { useTranslation } from "react-i18next";

import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function QtConsulting() {
    const { t } = useTranslation();

    return (
        <>
            <SEO
                title={t('qtconsulting.seoTitle')}
                description={t('qtconsulting.seoDescription')}
                keywords={t('qtconsulting.seoKeywords')}
                url="/qt-consulting"
                schemaType="service"
            />
            <TitleFragment title={t('qtconsulting.pageTitle')} />
        </>
    )
}

export default QtConsulting;